import { Injectable } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './services/auth/auth.service';
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | Observable<boolean> {
    const token = this.authService.getAccessToken(); // Fetch the access token from your service

    try {
      if (token && !this.authService.isTokenExpired(token)) {
        // Token is valid, allow access
        return true;
      } else {
        // Token is not valid, redirect to login
        this.router.navigate(['/login']);
        return false;
      }
    } catch (e) {
      this.router.navigate(['/login']);

      return false;
    }
  }
}